module.exports = __webpack_public_path__ + "img/braintree-integration.29ab7b92.png";